export const CONTENT_FEATURE_FLAGS = [
    {
        key: 'reactions',
        defaultValue: true,
        scope: 'global',
        ownerModule: 'content/reactions',
        description: 'Master article-reactions flag. When off, every /articles/:slug/reactions route returns 422 REACTIONS_DISABLED.',
        schemaVersion: 1,
    },
    {
        key: 'reactions.notify-author',
        defaultValue: false,
        scope: 'global',
        ownerModule: 'content/reactions',
        description: 'Notify the article author when a reader sets a reaction. Default off — a popular article would otherwise drown the author in pings; enable for low-traffic personal blogs.',
        schemaVersion: 1,
    },
    {
        key: 'reactions.realtime',
        defaultValue: false,
        scope: 'global',
        ownerModule: 'content/reactions',
        description: 'Push live reaction-count updates to the article reader via WebSocket / SSE. Reserved for the WS infra (plan.md X.3); the route shape already supports it.',
        schemaVersion: 1,
    },
    {
        key: 'bookmarks',
        defaultValue: true,
        scope: 'global',
        ownerModule: 'content/bookmarks',
        description: 'Master flag. Off → every /me/(collections|read-later|bookmarks) and /users/:userId/collections/:slug route returns 422 BOOKMARKS_DISABLED.',
        schemaVersion: 1,
    },
    {
        key: 'bookmarks.notify-author',
        defaultValue: false,
        scope: 'global',
        ownerModule: 'content/bookmarks',
        description: 'Notify the article author when a reader bookmarks the article. Default off — popular articles would otherwise drown the author. Day-bucket dedup so multi-collection bookmarking by the same user collapses to one ping.',
        schemaVersion: 1,
    },
    {
        key: 'bookmarks.read-later',
        defaultValue: true,
        scope: 'global',
        ownerModule: 'content/bookmarks',
        description: 'Enable the auto-managed Read Later collection. Off → POST /me/read-later/items returns 422 BOOKMARK_READ_LATER_DISABLED; existing read-later rows remain in the DB.',
        schemaVersion: 1,
    },
    {
        key: 'files',
        defaultValue: true,
        scope: 'global',
        ownerModule: 'content/files',
        description: 'Master flag. Off → every /me/(folders|files|uploads|recycle-bin|storage) route returns 422 FILES_DISABLED. The cron sweeper continues to run so abandoned upload sessions still expire.',
        schemaVersion: 1,
    },
    {
        key: 'files.versioning',
        defaultValue: true,
        scope: 'global',
        ownerModule: 'content/files',
        description: 'Honour same_name_strategy="keep-history" — store a file_versions row on overwrite. Off → "keep-history" requests are degraded to "overwrite" and the version_no never advances past 1; existing rows survive a flip.',
        schemaVersion: 1,
    },
    {
        key: 'files.dedup-md5',
        defaultValue: true,
        scope: 'global',
        ownerModule: 'content/files',
        description: 'Short-circuit upload-init when the supplied MD5 matches an existing file owned by the same user → return UploadInitResponse{kind:"deduped",existingFile} without creating an upload session. Off → every upload runs the full chunk pipeline.',
        schemaVersion: 1,
    },
    {
        key: 'files.recycle-bin',
        defaultValue: true,
        scope: 'global',
        ownerModule: 'content/files',
        description: 'Honour soft-delete with a 30-day grace window. Off → DELETE on a file or folder hard-purges immediately and the recycle-bin route is empty. The schema column stays in place; existing soft-deleted rows survive a flip.',
        schemaVersion: 1,
    },
    {
        key: 'files.public-downloads',
        defaultValue: true,
        scope: 'global',
        ownerModule: 'content/files',
        description: 'Allow guest viewers to read files in the `public-downloads` partition (anonymous browsing of the public file tree). Off → every file content stream requires a session.',
        schemaVersion: 1,
    },
    {
        key: 'files.share-links',
        defaultValue: true,
        scope: 'global',
        ownerModule: 'content/files',
        description: 'Allow owners to create bearer-token file share links with optional passcodes, expiry, access caps, revocation, and download audit logs.',
        schemaVersion: 1,
    },
    {
        key: 'files.downloads',
        defaultValue: true,
        scope: 'global',
        ownerModule: 'content/files',
        description: 'Enable the standalone downloads product: signed short-TTL file URLs, async folder/multi-file ZIP jobs, unified download logs, CDN-signing hooks, and hotlink/watermark policy checks.',
        schemaVersion: 1,
    },
    {
        key: 'files.chunked-upload',
        defaultValue: true,
        scope: 'global',
        ownerModule: 'content/files',
        description: 'Allow > 10 MiB uploads via the chunked-upload state machine. Off → init refuses totalSizeBytes > 10 MiB; small files still go through the same init-chunk-complete path.',
        schemaVersion: 1,
    },
    {
        key: 'files.preview-metadata',
        defaultValue: true,
        scope: 'global',
        ownerModule: 'content/files',
        description: 'Persist `preview` jsonb supplied by the SPA at /complete. Off → preview is always null; the SPA renders previews on-the-fly without server-stored metadata.',
        schemaVersion: 1,
    },
    {
        key: 'files.recycle-purge',
        defaultValue: true,
        scope: 'global',
        ownerModule: 'content/files',
        description: 'Cron: hard-purge soft-deleted files / folders past 30 days + sweep abandoned upload sessions past 24 h. Off → the cron arms its timer but no-ops; storage grows until manually emptied.',
        schemaVersion: 1,
    },
    {
        key: 'newsletters.paid-tier',
        defaultValue: false,
        scope: 'global',
        ownerModule: 'content/newsletters',
        description: 'Enable paid newsletter subscriber tiers.',
        schemaVersion: 1,
    },
    {
        key: 'newsletters.double-opt-in',
        defaultValue: true,
        scope: 'global',
        ownerModule: 'content/newsletters',
        description: 'Require confirmation before activating public newsletter subscriptions.',
        schemaVersion: 1,
    },
    {
        key: 'newsletters.bulk-delivery',
        defaultValue: true,
        scope: 'global',
        ownerModule: 'content/newsletters',
        description: 'Cron: deliver scheduled newsletter issues to the resolved subscriber segment in bounded batches.',
        schemaVersion: 1,
    },
    {
        key: 'newsletters.web-push',
        defaultValue: false,
        scope: 'global',
        ownerModule: 'content/newsletters',
        description: 'Allow push as an alternative newsletter delivery channel.',
        schemaVersion: 1,
    },
];
//# sourceMappingURL=registry-content.js.map